export default {"src":"/app/_next/static/media/et-1.4a7bc2a7.svg","height":398,"width":398,"blurWidth":0,"blurHeight":0};